import {IoSearchOutline} from "react-icons/io5"
import {RxHamburgerMenu} from "react-icons/rx"
import {IoHeartOutline} from "react-icons/io5"
import navbarStyles from "./navbar.module.css"

export const Navbar = () => {
	return (
		<>
			<section className={navbarStyles.navbar}>
				<div>
					<a href="#1">Home</a>
					<a href="#2">What is Bazi</a>
					<a href="#3">Our Story</a>
					<a href="#4">Benefits of Bazi</a>
					<a href="#5">Testimonials</a>
					<a href="#6">Review</a>
				</div>
			</section>

			<section className={navbarStyles.smallNavbar}>
				<div style={{display: ""}}>
					<h1 style={{color: "black", fontFamily: "Futura BT Pro Bold Italic", fontSize: "1.5rem"}}>Yi Nian Bazi</h1>
				</div>

				<div>
					<a href="#">
					</a>
				</div>
			</section>
		</>
	)
}
